/**
 * Empat jenis kiriman: bug, ide, pertanyaan, lain-lain.
 *
 * Sampai 19 Sep 2026 widget selalu mengirim `type: "bug"`, padahal servernya sudah
 * menerima keempatnya sejak awal (TYPES di apps/be/src/routes/feedback.ts). Akibatnya
 * setiap pertanyaan dan setiap ide masuk ke papan berlabel bug — dan tim membaca
 * kotak masuk yang isinya seolah seratus persen kerusakan.
 *
 * Bawaannya tetap "bug": itu yang paling sering benar, dan meminta orang memilih
 * lebih dulu sebelum ia boleh mengetik akan menambah satu pintu di depan satu-satunya
 * hal yang benar-benar kita butuhkan darinya — kalimatnya.
 */

export const FEEDBACK_TYPES = [
  { value: "bug", label: "Bug" },
  { value: "idea", label: "Idea" },
  { value: "question", label: "Question" },
  { value: "other", label: "Other" },
] as const;

export type FeedbackType = (typeof FEEDBACK_TYPES)[number]["value"];

export function TypePicker({
  value,
  onChange,
  disabled,
}: {
  value: FeedbackType;
  onChange: (next: FeedbackType) => void;
  disabled?: boolean;
}) {
  return (
    <div class="mf-type-row" role="radiogroup" aria-label="What kind of feedback is this?">
      {FEEDBACK_TYPES.map((t) => (
        <button
          key={t.value}
          type="button"
          role="radio"
          aria-checked={value === t.value}
          class="mf-type"
          data-on={value === t.value ? "" : undefined}
          onClick={() => onChange(t.value)}
          disabled={disabled}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
